import { Category } from '@mui/icons-material'
import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'manageLaboratory',
  initialState: {
    ScanCategoryList: [],
    ScanCategoryListDetails: [],
    ScanCategoryListLoading: false,
    ScanListPaginationData: {},
    ScanSubCategoryList: [],
    ScanSubCategoryListDetails: [],
    ScanSubCategoryListLoading: false,
    ScanCategoryListPaginationData: {},
    ScanTestList: [],
    ScanTestListLoading: false,
    ScanTestListPaginationData: {},
    ScanCategoryListDetailsLoading: false,
    ScanSubCategoryListDetailsLoading: false,

    updateLabSubCategory: false,
    updateLabTestList: false,

    addLabTestApiSuccess: false,
    deleteLabTestApiSuccess: false,
    editLabTestApiSuccess: false,
    labTestApiError: null,

    addLabTestCategoryApiSuccess: false,
    deleteLabTestCategoryApiSuccess: false,
    editLabTestCategoryApiSuccess: false,
    labTestCategoryApiError: null,

    updateScanCategory: false,
    modalOpen: false,
    error: '',
    updateScanTestList: false,
    categoryDetailsLoading: false,
    scanCategoryDetails: {},
  },
  reducers: {
    // get Scan category
    getListScanCategory: (state, { payload }) => {
      state.ScanCategoryListLoading = true
    },
    getListScanCategoryDataApiSuccess: (state, { payload }) => {
      state.ScanCategoryListLoading = false
      state.ScanCategoryList = payload?.payload?.data
      state.ScanCategoryListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getListScanCategoryDataApiFailed: (state, { payload }) => {
      state.ScanCategoryListLoading = false
    },

    // Scan get Test
    getListScanTest: (state, { payload }) => {
      state.ScanTestListLoading = true
    },
    getListScanTestDataApiSuccess: (state, { payload }) => {
      state.ScanTestListLoading = false
      state.ScanTestList = payload?.payload?.data
      state.ScanTestListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getListScanTestDataApiFailed: (state, { payload }) => {
      state.ScanTestListLoading = false
    },

    // Add Scan Category
    addScanCategory: (state, { payload }) => {
      state.ScanCategoryListLoading = true
      state.updateScanCategory = false
    },
    addScanCatagoriesDataApiSuccess: (state, { payload }) => {
      state.updateScanCategory = true
      state.ScanCategoryListLoading = false
      state.modalOpen = true
      state.error = payload?.payload
    },
    addScanCatagoriesDataApiFailed: (state, { payload }) => {
      state.ScanCategoryListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Add Scan Test
    addScanTest: (state, { payload }) => {
      state.updateScanTestList = false
      state.ScanTestListLoading = true
    },
    addScanTestDataApiSuccess: (state, { payload }) => {
      state.updateScanTestList = true
      state.ScanTestListLoading = false
      state.modalOpen = true
      state.error = payload?.payload
    },
    addScanTestDataApiFailed: (state, { payload }) => {
      state.ScanTestListLoading = false
      alert(JSON.stringify(payload, null, 2))
    },

    // Update Scan Category Data
    updateScanCategoryData: (state, { payload }) => {
      state.ScanCategoryList = state.ScanCategoryList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },

    updateScanCategoryDataApiSuccess: (state, { payload }) => {
      state.updateScanCategory = true
      state.ScanCategoryListLoading = false
      state.modalOpen = true
      state.error = payload?.payload
    },
    updateScanCategoryDataApiFailed: (state, { payload }) => {
      state.ScanCategoryListLoading = false
      alert(payload)
    },

    // Update Scan Category Data
    updateScanCenterTest: (state, { payload }) => {
      state.ScanTestList = state.ScanTestList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },

    updateScanCenterTestApiSuccess: (state, { payload }) => {
      state.updateScanTestList = true
      state.ScanTestListLoading = false
      state.modalOpen = true
      state.error = payload?.payload
    },
    updateScanCenterTestApiFailed: (state, { payload }) => {
      state.ScanTestListLoading = false
      alert(payload)
    },

    // delete category data
    deleteScanCategory: (state, { payload }) => {
      state.updateScanCategory = false
      state.ScanCategoryListLoading = true
      let updatedCategoryList = state.ScanCategoryList?.filter((item) => item.id !== payload?.id)
      state.ScanCategoryList = updatedCategoryList
    },
    deleteScanCategoryDataApiSuccess: (state, { payload }) => {
      state.updateScanCategory = true
      state.ScanCategoryListLoading = false
      state.modalOpen = true
      state.error = payload?.payload
    },
    deleteScanCategoryDataApiFailed: (state, { payload }) => {
      state.ScanCategoryListLoading = false
      alert(payload)
    },

    // delete Lab Test
    deleteScanTest: (state, { payload }) => {
      state.updateScanTestList = false
      state.ScanTestListLoading = true
    },
    deleteScanTestApiSuccess: (state, { payload }) => {
      state.updateScanTestList = true
      state.ScanTestListLoading = false
      state.modalOpen = true
      state.error = payload?.payload
    },
    deleteScanTestApiFailed: (state, { payload }) => {
      alert(payload)
      state.ScanTestListLoading = false
    },
    // getScanCategoryDetails
    getScanCategoryDetails: (state, { payload }) => {
      state.categoryDetailsLoading = true
    },
    getScanCategoryDetailsApiSuccess: (state, { payload }) => {
      state.scanCategoryDetails = payload?.payload?.data
      state.categoryDetailsLoading = false
    },
    getScanCategoryDetailsFailed: (state, { payload }) => {
      state.categoryDetailsLoading = false
    },

    resetError: (state) => {
      state.modalOpen = false
      state.error = ''
      state.updateScanCategory = ''
      state.updateScanTestList = false
      
    },
  },
})

export const {
  // get Scan Category
  getListScanCategory,
  getListScanCategoryDataApiSuccess,
  getListScanCategoryDataApiFailed,

  // get Scan test
  getListScanTest,
  getListScanTestDataApiSuccess,
  getListScanTestDataApiFailed,

  // Add lab Test
  addScanCategory,
  addScanCatagoriesDataApiSuccess,
  addScanCatagoriesDataApiFailed,

  // Add Scan Test
  addScanTest,
  addScanTestDataApiSuccess,
  addScanTestDataApiFailed,

  // Update Scan Category
  updateScanCategoryData,
  updateScanCategoryDataApiSuccess,
  updateScanCategoryDataApiFailed,
  // Update Scan Test
  updateScanCenterTest,
  updateScanCenterTestApiSuccess,
  updateScanCenterTestApiFailed,
  // delete Scan category data
  deleteScanCategory,
  deleteScanCategoryDataApiSuccess,
  deleteScanCategoryDataApiFailed,
  // delete Scan Test
  deleteScanTest,
  deleteScanTestApiSuccess,
  deleteScanTestApiFailed,

  // getScanCategoryDetails
  getScanCategoryDetails,
  getScanCategoryDetailsApiSuccess,
  getScanCategoryDetailsFailed,
  // reset
  resetError,
} = slice.actions

export default slice.reducer
